import React, { type FC } from "react";
import { CardHeader } from "@shared/ui/card-header";
import { SkeletonRow } from "@src/components/skeleton-row";
import "./CardLoader.scss";

/** Пропсы {@link CardLoader}. */
export interface CardLoaderProps {
    /**
     * Показать шапку «Загрузка...».
     * @default false
     */
    header?: boolean;
    /**
     * Показать skeleton кнопок формы.
     * @default false
     */
    btns?: boolean;
    /**
     * Показать skeleton списка.
     * @default false
     */
    list?: boolean;
}

/**
 * Skeleton-placeholder карточки на время загрузки detail-данных.
 */
export const CardLoader: FC<CardLoaderProps> = ({ btns = false, header = false, list = false }) => {
    return (
        <div className="card_loader">
            {header && <CardHeader text="Загрузка..." />}
            <div className="card_loader__body">
                <div className="card_loader__content">
                    <div className="loader_section main_section">
                        <SkeletonRow className="input_loader" widthInProcent={100} />
                        <SkeletonRow widthInProcent={60} />
                        <SkeletonRow widthInProcent={70} />
                        <SkeletonRow widthInProcent={50} />
                        <SkeletonRow className="input_loader" widthInProcent={100} />
                        <SkeletonRow widthInProcent={50} />
                        <div className="row_both_inputs">
                            <SkeletonRow className="input_loader" widthInProcent={100} />
                            <SkeletonRow className="input_loader" widthInProcent={100} />
                        </div>
                        <SkeletonRow className="input_loader" widthInProcent={100} />
                    </div>
                    <div className="loader_section bottom_section">
                        {list && (
                            <div className="list_loader_container">
                                <SkeletonRow className="list_loader" />
                            </div>
                        )}
                        {btns && (
                            <div className="btns_loader">
                                <SkeletonRow className="button_loader" />
                                <SkeletonRow className="button_loader" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
